module.exports = __webpack_public_path__ + "static/media/elementary-os-logo.8cf23518.svg";